export default __webpack_public_path__ + "static/media/admin.10de0c91.png";